import type { MetricLineTimeChartMetric } from '@/app/common/components/charts/MetricLineTimeChart';
import type {
  GscDateChartData,
  GscDateTotalsData
} from '@/app/KeywordResearch/types/gscApiTypes';
import { getColor } from '@/helpers/utils';

export const mapGscDateChartData = (
  apiData: GscDateChartData,
  totals: GscDateTotalsData
) => ({
  dates: apiData.dates,
  metrics: [
    {
      id: 'clicks',
      label: 'کل کلیک‌ها',
      total: totals.clicks,
      data: apiData.clicks,
      color: '#3b82f6',
      axisLabel: 'کلیک',
      tooltip: 'تعداد کل کلیک‌های ثبت‌شده در بازه زمانی انتخاب‌شده.'
    },
    {
      id: 'impressions',
      label: 'کل نمایش‌ها',
      total: totals.impressions,
      data: apiData.impressions,
      color: getColor('purple'),
      axisLabel: 'نمایش',
      tooltip: 'تعداد دفعاتی که سایت شما در نتایج جستجو نمایش داده شده است.'
    },
    {
      id: 'ctr',
      label: 'میانگین CTR',
      total: totals.avg_ctr,
      data: apiData.ctr,
      color: getColor('success'),
      axisLabel: 'CTR',
      axisFormatter: (value: number | string) =>
        `${Number(value).toFixed(1).toPersianDigit()}%`,
      tooltip: 'میانگین نرخ کلیک در بازه زمانی.'
    },
    {
      id: 'position',
      label: 'میانگین رتبه',
      total: totals.avg_position,
      data: apiData.position,
      color: getColor('warning'),
      axisLabel: 'رتبه',
      inverse: true,
      tooltip: 'میانگین موقعیت سایت در نتایج جستجو.'
    }
  ] satisfies MetricLineTimeChartMetric[]
});
